import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const RegiaoVendedorCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [stateRegioes, setStateRegioes] = useState([]);
  const [stateVendedores, setStateVendedores] = useState([]);
  //const [stateEstados, setStateEstados] = useState([]);

  const [state, setState] = useState({
    id: 0,
    estado_id: "",
    descricao: "",
    vendedor_id: "",
    regiao_id: "",
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-regiao-vendedor").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/regiao-vendedor", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/regiao-vendedor");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar a região x vendedor.");
    }
  };

  const buscarDados = async (url) => {
    const requisicao = await api.get(`${url}`);

    const { data } = requisicao;

    if (!data.status) {
      danger(data.mensagem);
      return;
    }

    if (!data.data) {
      return;
    }

    return data.data;
  };

  const carregarRegioes = async () => {
    return await buscarDados("/regiao-vendedor/regiao");
  };

  const carregarVendedores = async () => {
    return await buscarDados("/regiao-vendedor/vendedor");
  };

  // const carregarEstados = async () => {
  //   return await buscarDados("/regiao-vendedor/estado");
  // };

  const carregarDados = async () => {
    if (!location.state) {
      return;
    }

    return await buscarDados(`/regiao-vendedor/${location.state.id}`);
  };

  useEffect(() => {
    const carregarTodosDados = async () => {
      try {
        showLoading(".ibox-content");

        const [regioes, vendedores, regiaoVendedor] =
          await Promise.all([
            carregarRegioes(),
            carregarVendedores(),
            //carregarEstados(),
            carregarDados(),
          ]);

        setStateRegioes(regioes);
        setStateVendedores(vendedores);
        //setStateEstados(estados);

        if (regiaoVendedor) {
          setState(regiaoVendedor);
        }

        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados da região x vendedor.");
      }
    };

    let validacao = window.$("#form-regiao-vendedor").validate(validate);

    carregarTodosDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Regiões x Vendedores"
        header="Cadastro da Região x Vendedor"
        action={{ titulo: "Voltar", link: "/regiao-vendedor" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados da região x vendedor</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-regiao-vendedor">
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Selecione um vendedor</label>
                            <select
                              className="form-control"
                              id="vendedor_id"
                              name="vendedor_id"
                              value={state.vendedor_id}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="-1" value="">
                                Selecione um vendedor
                              </option>

                              {stateVendedores
                                .sort((a, b) => (a.nome > b.nome ? 1 : -1))
                                .map((vendedor) => (
                                  <option key={vendedor.id} value={vendedor.id}>
                                    {vendedor.nome}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Selecione a região</label>
                            <select
                              className="form-control"
                              id="regiao_id"
                              name="regiao_id"
                              value={state.regiao_id}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="-1" value="">
                                Selecione uma região
                              </option>

                              {stateRegioes
                                .sort((a, b) =>
                                  a.descricao > b.descricao ? 1 : -1
                                )
                                .map((regiao) => (
                                  <option key={regiao.id} value={regiao.id}>
                                    {regiao.descricao}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Descrição da região</label>
                            <input
                              type="text"
                              placeholder="Descrição da região"
                              className="form-control"
                              name="descricao"
                              value={state.descricao}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        
                        
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default RegiaoVendedorCadastrar;
